import React, { useEffect, useState } from 'react'
import { Button, Form, Input } from 'antd'
import {
  PlusOutlined,
  FileExcelOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import styles from './Step1.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import templateIcon from './templateIcon.svg'
const { TextArea } = Input
const Step1 = (props) => {
  useEffect(() => {}, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div>
      <div className={styles.topContainer}>
        <div className={styles.templateContainer}>
          <img className={styles.templateImg} src={templateIcon} alt="" />
          <span className={styles.templateTitle}>下载批量账号模板</span>
        </div>
        <div className={styles.templateDesc}>
          请下载模板并填写详细信息，然后上传文件完成批量账号开通。请确保文件格式正确且内容完整。
        </div>
        <Button
          type="primary"
          style={{ marginTop: 20 }}
          icon={<DownloadOutlined />}
          onClick={() => {
            window.open(
              'https://tgnp.oss-cn-qingdao.aliyuncs.com/ygbh/ygbhApplication/xh-file/%E8%B6%8A%E5%85%89%E5%AE%9D%E7%9B%92%E8%B4%A6%E5%8F%B7%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E6%A8%A1%E6%9D%BF%20.xlsx',
            )
          }}
        >
          点击下载Excel模板
        </Button>
      </div>
      <div className={styles.bottomContainer}>
        <div className={styles.bottomTitle}>模板填写说明：</div>
        <div className={styles.bottomDesc}>
          1. 请严格按照模板格式填写，确保数据的准确性。
          <br />
          2. 请勿修改模板结构，否则可能导致导入失败。
          <br />
          3. 账号开通后，<span style={{ color: '#000', fontWeight: 'bold' }}>登录账号为手机号，初始密码为
          000000。</span>
          为保障账户安全，请在首次登录后立即修改密码。
          <br />
          4.
          “身份”与“授课年级”列仅需填写一个主要身份，请勿填写多个身份，否则可能导致导入失败。
        </div>
      </div>
      <Button
        type="primary"
        style={{ marginTop: 20,marginLeft: "820px" }}
        onClick={() => {
          props.nextStep()
        }}
      >
        下一步
      </Button>
    </div>
  )
}

export default Step1
